module.exports = __webpack_public_path__ + "static/media/cornell-paper-2.6ad3a1fe.png";